export default "__VITE_ASSET__3JbuxRm0__"